import type { OrganisationPeriodJob } from 'state/__generated__/tadaahAPI';
import { useApiOrganisationPeriodJobsList } from 'state/__generated__/tadaahAPI';

type UseGetPeriodjobsListHandler = {
  data: OrganisationPeriodJob[];
  error: string | undefined;
  isLoading: boolean;
};

const useGetOrganisationPeriodJobs = (): UseGetPeriodjobsListHandler => {
  const { data, error, isLoading } = useApiOrganisationPeriodJobsList({
    query: {
      queryKey: 'organisation-period-jobs',
    },
  });
  return { data: data?.data ?? [], error: error?.message, isLoading };
};

export default useGetOrganisationPeriodJobs;
